module.exports = __webpack_public_path__ + "static/media/intro.14a0f4ba.mp3";